import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pg-card, grit-card',
  templateUrl: './pg-card.component.html',
  styleUrls: ['./pg-card.component.scss'],
  exportAs: 'gritCard',
})
export class PgCardComponent implements OnInit {
  @Input()
  get elevation() {
    return this._elevation;
  }
  set elevation(value: number) {
    this.hostEl.classList.remove(`pg-elevation-${this._elevation}`);
    this._elevation = value;
    this.hostEl.classList.add(`pg-elevation-${this._elevation}`);
  }
  protected _elevation;

  get hostEl(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {
    if (!this.elevation) {
      this.elevation = 1;
    }
  }
}
